const TickHistoryContentFour = () => {
  return (
    <div className="how__work__resource">
      <div className="container">
        <div className="contact__cards row">
          <div className="col-lg-6 col-md-6 col-12 mb-4">
            <div className="contact__card">
              <div className="card-header">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/markets/instant_withdrawals.png"
                  }
                  alt="play icon"
                />
                <h4>Granular Tick-Level Data</h4>
              </div>
              <p>
                Access detailed bid/ask records and timestamps for all supported
                instruments.
              </p>
            </div>
          </div>

          <div className="col-lg-6 col-md-6 col-12 mb-4">
            <div className="contact__card">
              <div className="card-header">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/markets/instant_withdrawals.png"
                  }
                  alt="play icon"
                />
                <h4>Transparency You Can Trust</h4>
              </div>
              <p>
                Get unfiltered market data straight from trusted liquidity
                sources for full transparency.
              </p>
            </div>
          </div>

          <div className="col-lg-6 col-md-6 col-12 mb-4">
            <div className="contact__card">
              <div className="card-header">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/markets/instant_withdrawals.png"
                  }
                  alt="play icon"
                />
                <h4>Backtesting Made Easy</h4>
              </div>
              <p>
                Enhance your trading models with historical performance
                validation and risk simulations..
              </p>
            </div>
          </div>

          <div className="col-lg-6 col-md-6 col-12 mb-4">
            <div className="contact__card">
              <div className="card-header">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/markets/instant_withdrawals.png"
                  }
                  alt="play icon"
                />
                <h4>Multi-Asset Coverage</h4>
              </div>
              <p>
                Our multilingual support team is ready to assist you anytime.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TickHistoryContentFour;
